<template>
  <li class="select-lang rd-nav-item">
    <a
      class="toggle-link rd-nav-link d-inline-flex align-items-center"
      href=""
      @click.prevent
    >
      <BaseIcon
        class="flag-icon"
        :name="`icons:${FLAGS_MAP[currentLocale?.code]}`"
      />
      <span>
        {{
          currentLocale?.shortName ||
          currentLocale?.nativeName ||
          currentLocale?.name
        }}
      </span>
    </a>

    <ul class="rd-menu rd-navbar-dropdown">
      <li v-for="locale in locales" :key="locale.code" class="rd-dropdown-item">
        <a
          class="rd-dropdown-link d-flex align-items-center"
          :href="linkToLocale(locale)"
          @click.prevent="changeLanguage(locale, $event)"
        >
          <BaseIcon
            class="flag-icon"
            :name="`icons:${FLAGS_MAP[locale.code]}`"
          />
          <span>{{ locale.nativeName || locale.name }}</span>
          <BaseIcon
            v-if="
              currentLocale?.code.toLowerCase() === locale.code.toLowerCase()
            "
            class="check-icon"
            name="icons:check"
          />
        </a>
      </li>
    </ul>
  </li>
</template>

<script setup>
import { storeToRefs } from "pinia";

const route = useRoute();
const globalStore = useGlobalStore();
const { locales, currentLocale } = storeToRefs(globalStore);
const isProcess = ref(false);
const cookieLanguage = useCookie("user-language", {
  maxAge: 60 * 60 * 24 * 365 * 10,
});

const FLAGS_MAP = {
  ua: "flag-ukraine",
  en: "flag-usa",
};

const changeLanguage = async (locale, event) => {
  if (currentLocale.value?.code === locale.code || isProcess.value) return;
  isProcess.value = true;
  const href = event.currentTarget.attributes.href.value;
  cookieLanguage.value = locale.code.toLowerCase();

  window.location.href = href || `/${locale.code.toLowerCase()}`;
};

const linkToLocale = (locale) => {
  const routerLocale = route.params.locale;
  const pathRegexp = new RegExp(`^/${routerLocale}/|^/${routerLocale}$`);
  const pathWithoutLocale = routerLocale
    ? route.fullPath.replace(pathRegexp, "/")
    : route.fullPath;

  if (locale.isDefault) return pathWithoutLocale;
  return `/${locale.code.toLowerCase()}${
    pathWithoutLocale === "/" ? "" : pathWithoutLocale
  }`;
};
</script>

<style lang="scss" scoped>
.select-lang {
  position: relative;
  vertical-align: middle;
}

.toggle-link {
  width: 100%;

  @media (min-width: 1200px) {
    width: auto;
  }
}

.flag-icon {
  margin-right: 6px;
}

.check-icon {
  margin-left: auto;
}

.rd-navbar-dropdown {
  position: absolute;
  z-index: -41;
  left: unset;
  right: 0;
  margin-top: 3px;
  padding: 0;
  background: #ffffff;
  border: none;
  overflow: hidden;
  transition: 0.35s all cubic-bezier(0.65, 0.05, 0.36, 1);

  @media (max-width: 1199px) {
    width: 200px;
  }

  & > li > a {
    @media (max-width: 1199px) {
      padding: 9px 16px !important;
    }
  }
}
</style>
